import { EMAIL_INVALID, PASSWORD_INVALID, USERNAME_INVALID } from '@ogsnetwork/opp-api-lib';
export function validatePassword(password) {
    const passwordDigitRegex = /\d/;
    const passwordLetterRegex = /[a-zA-Z]/;
    if (!passwordDigitRegex.test(password) || !passwordLetterRegex.test(password) || password.length < 8) {
        const errors = {
            password: [
                {
                    type: PASSWORD_INVALID,
                    message: 'Password must contain both letters and numbers and be 8 or more characters'
                }
            ]
        };
        return { isValid: false, errors };
    }
    return { isValid: true };
}
export function validateEmail(email) {
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const emailTest = emailRegex.test(email);
    if (!emailTest && email.length > 0) {
        const errors = {
            email: [
                {
                    type: EMAIL_INVALID,
                    message: 'Email is invalid'
                }
            ]
        };
        return { isValid: false, errors };
    }
    return { isValid: true };
}
export function validateUsername(username) {
    if (username.length < 3 || username.length > 24) {
        const errors = {
            username: [
                {
                    type: USERNAME_INVALID,
                    message: 'Username must be 3 or more characters and less than 25'
                }
            ]
        };
        return { isValid: false, errors };
    }
    return { isValid: true };
}
